import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import LayersIcon from '@material-ui/icons/Layers'
import IconButton from '@material-ui/core/IconButton';


const styles = theme => ({
    button: {
        // margin: theme.spacing.unit,
        outline: 'none !important',
    },
    formControl: {
        display: 'none',
    },
    selectMenu: {
        display: 'none',
    }
});

const ITEM_HEIGHT = 48;


@withStyles(styles)
class SelectFramesButton extends React.Component {

    static propTypes = {
        component: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            frame: [],
            open: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        //console.log(this.props.structureComponent.setSelection("/0/1/2"));
        //this.props.structureComponent.rebuildRepresentations();
    }

    handleChange = event => {
        console.log("Handle frame selection");
        this.setState({[event.target.name]: event.target.value},
            () => {
                console.log(this.state[event.target.name]);
                // TODO: multiple frame selection not implemented ?
                // var selection = "/".concat(this.state[event.target.name].join("/"));
                // this.props.structureComponent.setSelection(selection);
                this.props.component.setSelection("/" + event.target.value);
            });
    };

    handleClose = () => {
        this.setState({open: false});
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    render() {
        const {classes} = this.props;

        return (
            <form autoComplete="off">

                <IconButton edge='end' color="primary" className={classes.button}
                            aria-label="Select frames"
                            onClick={this.handleOpen}
                            buttonRef={node => {
                                this.anchorEl = node;
                            }}><LayersIcon fontSize="small"/>
                </IconButton>

                <FormControl className={classes.formControl}>
                    <Select
                        autoWidth
                        className={classes.selectMenu}
                        open={this.state.open}
                        displayEmpty={false}
                        IconComponent={LayersIcon}
                        MenuProps={{
                            anchorEl: this.anchorEl,
                            PaperProps: {
                                style: {
                                    maxHeight: ITEM_HEIGHT * 4.5,
                                    width: 200,
                                },
                            },
                        }}
                        // TODO: selection multiple des frames ne semble pas fonctionner ...
                        // multiple={true}
                        multiple={false}
                        onClose={this.handleClose}
                        onOpen={this.handleOpen}
                        value={this.state.frame}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'frame',
                            id: 'select-frames-button',
                        }}
                    >
                        <MenuItem value={""}>all</MenuItem>
                        {this.props.component.structure.modelStore.count && Array.from({length: this.props.component.structure.modelStore.count}, (_, id) => ({id})).map((modelItem) =>
                            <MenuItem value={modelItem.id.toString()}
                                      key={modelItem.id.toString()}>{modelItem.id + 1}</MenuItem>
                        )}
                    </Select>
                </FormControl>

            </form>
        );
    }
}

export default SelectFramesButton;